const ON_CHANGE_DEBOUNCE_TIMER = 300;
const DEBUG = true;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};



const PRODUCT_CARD_2 = {
  SECTION_ID: "product-card-2",
  PRODUCT_DETAILS_JSON_ID: "SwatchProductDetails",
  SWATCH_TRIGGER: 'product-card-2-swatches__swatch',
  CLASSNAME_STATE: {
    HIDDEN: "tw-hidden"
  },
  CLASS_SELECTOR: {
    PRODUCT_CARD : "product-card-2__wrapper",
    CARD_IMAGE: "product-card-2__image",
    CARD_INFO_WRAPPER: "product-card-2__info-wrapper",
    CARD_TITLE : "product-card-2__title",
    PRICE_WRAPPER: "product-card-2__price-wrapper",
    SALE_PRICE_WRAPPER: "product-card-2__sale-price-wrapper",
    SALE_PRICE: "product-card-2__sale-price",
    ORIGINAL_PRICE_WRAPPER: "product-card-2__original-price-wrapper",
    ORIGINAL_PRICE: "product-card-2__original-price",
    DISCOUNT_WRAPPER: "product-card-2__discount-wrapper",
    DISCOUNT: "product-card-2__discount",
    REDTAB_MEMBER_PRICE: "product-card-2__redtab-member-price",
    GST_BENEFIT_TAG: "product-card-2__gst-benefit-included-tag",
    UNITS_SOLD_WRAPPER: "product-card-2__x-units-sold-wrapper",
    UNITS_SOLD: "product-card-2__x-units-sold",
    LABELS_WRAPPER: "product-card-2-labels__wrapper",
    NEW_LABEL: "product-card-2-labels__new-label",
    RV_LABELS_WRAPPER: "rv-product-card-2__labels",
    RV_NEW_LABEL: "rv-product-card-2-labels__new-badge",
    REDLOOP_LABEL: "product-card-2-labels__redloop-label",
    CARD_SWATCHES_WRAPPER: "product-card-2-swatches__wrapper",
    CARD_SWATCH: "product-card-2-swatches__swatch",
    SWATCHES_VIEW_MORE: "product-card-2-swatches__view-more"
  },
  HTML_MARKUP: {
    SALE_PRICE: "",
    ORIGINAL_PRICE: "",
    DISCOUNT: ""
  }
}